import React from 'react';
import { Link } from 'react-router-dom';

function PersonCard({setTargetProcess, setPerson, initialPerson}) {
    const person = {
        photo: localStorage.getItem('person-photo'),
        name: localStorage.getItem('person-name'),
        age: localStorage.getItem('person-age'),
        email: localStorage.getItem('person-email'),
        phone: localStorage.getItem('person-phone'),
        title: localStorage.getItem('person-title'),
        position: localStorage.getItem('person-position'),
        skills: localStorage.getItem('person-skills').split(' '),
    }

    const handelDown = (e) => {
        const ch = document.querySelector('.person-container');

        let prevX = e.clientX;
        let prevY = e.clientY;

        const handMove = (e) => {
            let newX = prevX - e.clientX;
            let newY = prevY - e.clientY;

            const rect = ch.getBoundingClientRect();
            ch.classList.add('perCarActive');
            ch.style.position = 'absolute';
            ch.style.left = rect.left - newX + 'px';
            ch.style.top = rect.top - newY + 'px';

            prevX = e.clientX;
            prevY = e.clientY;
        }

        const handUp = () => {
            ch.classList.remove('perCarActive');
            window.removeEventListener('mousemove', handMove);
            window.removeEventListener('mouseup', handUp);
        }


        window.addEventListener('mousemove', handMove);
        window.addEventListener('mouseup', handUp);
    }
    return (
        <section id='person-card'>
            <div className='person-container' onMouseDown={handelDown}>
                <div className="person-container___row1">
                    <div className="person-container___row1__col1">
                        <img src={person.photo} alt='img1'/>
                    </div>
                    <div className="person-container___row1__col2">
                        <p>{`${person.name} - ${person.age} year`}</p>
                        <p> <span>{person.position}</span>  <span>{person.title}</span> </p>
                    </div>
                </div>
                <div className="person-container___row2">
                    <p>Experince</p>
                    <div className="person-container___row2__skillsWrapper">{
                        person.skills.map( (skill, i) => {return(
                            (skill.length > 1) &&
                            <span key={i}>{skill}</span>
                        )} )
                    }</div>
                </div>
                <div className="person-container___row3">
                    <div className="person-container___row3__col1">
                        <p>
                            <img src="https://img.icons8.com/material/24/606060/phone--v1.png" alt='imgIc'/>
                            {person.phone}
                        </p>
                    </div>
                    <div className="person-container___row3__col2">
                        <p>
                            <img src="https://img.icons8.com/material/24/606060/new-post--v1.png" alt='imgIc'/>
                            {person.email}
                        </p>
                    </div>
                </div>
            </div>
            <div className='person-container___row4'>     
            <div className="person-container___row4__col1">
                <img src="https://img.icons8.com/ios-filled/24/ffffff/pen.png" alt='imgIc'/>
                <Link to='/PersonalForm/edit' onClick={() => {
                        setTargetProcess('edit');
                        setPerson({...person, skills: localStorage.getItem('person-skills')});
                }}>Back to edit</Link>
            </div>
            <div className="person-container___row4__col2">
                <img src="https://img.icons8.com/ios-filled/24/ffffff/plus-math.png" alt='imgIc'/>
                <Link to='/PersonalForm/' onClick={() => {
                        setTargetProcess('');    
                        setPerson(initialPerson);
                }}>Change All</Link>
            </div>
            </div>
        </section>
    )
}

export default PersonCard
